import React from "react";
import { connect } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";

const ConfirmationModal = ({ open, onClose, isLoading, onSubmit, title, message, confirmButtonText }) => {
  return (
    <Modal isOpen={open} toggle={isLoading ? () => { } : onClose} centered style={{ maxWidth: "30vw" }}>
      <ModalHeader toggle={onClose}>
        <span style={{ fontSize: "18px", fontWeight: "700", textTransform: "uppercase" }}>
          {title || "Are you Sure ?"}
        </span>
      </ModalHeader>
      <ModalBody>
        <h6>{message || "Are you sure you want to delete these ?"}</h6>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={onClose}
          outline
          type='submit'
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={onSubmit}
          type='submit'
          disabled={isLoading}
        >
          {isLoading ? (
            <Spinner size="sm" color="light" />
          ) : (
            confirmButtonText || "Delete"
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationModal);
